import { isEqualUtil } from '../../lang'

export default function areDeepEqualArrayUtil (array1, array2) {
  // Check if both arrays have the same length
  if (array1.length !== array2.length) {
    return false
  }

  // Check if each element in the arrays is equal
  for (let i = 0; i < array1.length; i++) {
    if (!isEqualUtil(array1[i], array2[i])) {
      return false
    }
  }

  // If the lengths and elements are the same, the arrays are equal
  return true
}
